import { Box, Button, IconButton, Modal, ModalProps } from '@mui/material';
import { CloseIcon } from '~/assets/icons';
import styles from './ModalAlertDelete.module.scss';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';

const cx = classNames.bind(styles);

type ModalAlertDeleteProps = Omit<ModalProps, 'children'> & {
  title?: string;
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const ModalAlertDelete = (props: ModalAlertDeleteProps) => {
  const { title, description, onCancel, onConfirm, ...restProps } = props;
  const { t } = useTranslation('admin/common');

  return (
    <Modal {...restProps}>
      <Box className={cx('modal-container')}>
        <IconButton className='absolute top-[10px] right-[10px]' onClick={onCancel}>
          <CloseIcon className='w-[24px] h-[24px]' fill='#FF2D55' />
        </IconButton>

        <Box className={cx('content-container')}>
          <Box className={cx('icon-delete', 'p-[12px]')}>
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M52.5 10H44.75C44.1698 7.17853 42.6346 4.64336 40.4031 2.8218C38.1717 1.00023 35.3805 0.00363631 32.5 0L27.5 0C24.6195 0.00363631 21.8283 1.00023 19.5969 2.8218C17.3655 4.64336 15.8302 7.17853 15.25 10H7.5C6.83696 10 6.20107 10.2634 5.73223 10.7322C5.26339 11.2011 5 11.837 5 12.5C5 13.163 5.26339 13.7989 5.73223 14.2678C6.20107 14.7366 6.83696 15 7.5 15H10V47.5C10.004 50.814 11.3222 53.9911 13.6655 56.3345C16.0089 58.6778 19.186 59.996 22.5 60H37.5C40.814 59.996 43.9911 58.6778 46.3345 56.3345C48.6778 53.9911 49.996 50.814 50 47.5V15H52.5C53.163 15 53.7989 14.7366 54.2678 14.2678C54.7366 13.7989 55 13.163 55 12.5C55 11.837 54.7366 11.2011 54.2678 10.7322C53.7989 10.2634 53.163 10 52.5 10V10ZM27.5 5H32.5C34.0507 5.00189 35.5628 5.48344 36.829 6.37861C38.0952 7.27378 39.0535 8.53873 39.5725 10H20.4275C20.9465 8.53873 21.9048 7.27378 23.171 6.37861C24.4372 5.48344 25.9493 5.00189 27.5 5V5ZM45 47.5C45 49.4891 44.2098 51.3968 42.8033 52.8033C41.3968 54.2098 39.4891 55 37.5 55H22.5C20.5109 55 18.6032 54.2098 17.1967 52.8033C15.7902 51.3968 15 49.4891 15 47.5V15H45V47.5Z" fill="#FF2D55" />
              <path d="M25 44.998C25.663 44.998 26.2989 44.7346 26.7678 44.2658C27.2366 43.7969 27.5 43.1611 27.5 42.498V27.498C27.5 26.835 27.2366 26.1991 26.7678 25.7303C26.2989 25.2614 25.663 24.998 25 24.998C24.337 24.998 23.7011 25.2614 23.2322 25.7303C22.7634 26.1991 22.5 26.835 22.5 27.498V42.498C22.5 43.1611 22.7634 43.7969 23.2322 44.2658C23.7011 44.7346 24.337 44.998 25 44.998Z" fill="#FF2D55" />
              <path d="M35 44.998C35.6631 44.998 36.2989 44.7346 36.7678 44.2658C37.2366 43.7969 37.5 43.1611 37.5 42.498V27.498C37.5 26.835 37.2366 26.1991 36.7678 25.7303C36.2989 25.2614 35.6631 24.998 35 24.998C34.337 24.998 33.7011 25.2614 33.2322 25.7303C32.7634 26.1991 32.5 26.835 32.5 27.498V42.498C32.5 43.1611 32.7634 43.7969 33.2322 44.2658C33.7011 44.7346 34.337 44.998 35 44.998Z" fill="#FF2D55" />
            </svg>


            {/* <TrashIcon className='w-[60px] h-[60px]' /> */}
          </Box>

          {/* <Box className={cx('alert-title')}>{title ?? t('alertTitle')}</Box> */}
          <Box className={cx('alert-description')}>{description ? description : "Do you want to delete this?"}</Box>
        </Box>

        <Box className={cx('footer-container')}>
          <Button
            className='text-[#F9FBFE] border-1 border-[#1A2B47] h-[48px] w-[167px] flex-1 hover:border-none hover:bg-[#1A2B47]'
            variant='outlined'
            disableElevation
            onClick={onCancel}
          >
            {t('cancel')}
          </Button>

          <Button className='ml-[10px] flex-1 text-[#F9FBFE] bg-[#FF2D55] border-0 h-[48px] w-[167px] flex-1 hover:border-none hover:bg-[#FF2D55]' variant='contained' disableElevation onClick={onConfirm}>
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default memo(ModalAlertDelete);
